import React from 'react';

const UnderConstruction = () => <div>Page in Development</div>;

UnderConstruction.propTypes = {};

UnderConstruction.defaultProps = {};

export default UnderConstruction;
